export default __webpack_public_path__ + "static/media/tic-tac-toe.4418a710.png";